function initialState() {
  return {
    refreshes: {},
  }
}

let state = initialState()

export { initialState, state }
